import {
  FORGET_PASSWORD_REQUEST,
  LOGIN_STATUS,
  RESET_PASSWORD,
  SHOW_FORGOT_MODAL,
  SHOW_WELCOME_SCREEN,
  UPDATE_INTERNET_STATUS,
} from './ActionTypes';

export const SendingNewPasswordRequest = (emailId, callback) => {
  return {
    type: FORGET_PASSWORD_REQUEST,
    emailId: emailId,
    callback: callback,
    isChecking: true,
  };
};
export const canShowForgotPassWordModel = (canShow, message) => {
  return {
    type: SHOW_FORGOT_MODAL,
    canShow: canShow,
    message: message,
  };
};

export const updateInternetStatus = (status) => {

  return {
    type: UPDATE_INTERNET_STATUS,
    isNetConnected: status,
  };
};

export const resetPasswordField = (status) => {
  return {
    type: RESET_PASSWORD,
    isPasswordFieldReset: status,
  };
};

export const blockLogin = (status) => {
  return {
    type: LOGIN_STATUS,
    loginStatue: status,
  };
};

/*********** welcome screen ************/
export const go_to_welcomeScreen = () => {
  return {
    type: SHOW_WELCOME_SCREEN,
  };
};
/**************************************/





